/* eslint react/jsx-pascal-case: 0 */
import React from 'react'
import Grid from '@mui/material/Grid'
import { ACCOUNT_MENU } from 'constants/account-menu'
import NotFound from 'components/NotFound'
import NavigationContainer from 'redux/containers/components/account/NavigationContainer'

const Account = ({ view = 'details', flavour, query, option, userIs, aol }) => {
  const View = ACCOUNT_MENU[view]
  return ((!View || View.role) && !userIs(View.role))
    ? <NotFound />
    : (
      <div className='layout-width-constraint'>
        <Grid container spacing={2}>
          <Grid item xs={12} sx={{ display: { xs: 'block', md: 'none' } }}>
            <NavigationContainer {...{ views: ACCOUNT_MENU, view, aol }} />
          </Grid>
          <Grid item md={4} lg={3} sx={{ display: { xs: 'none', md: 'block' } }}>
            <div className='fixed left0 pt3 pl7 pr6 h-100 shadow-black-1' style={{ width: 'inherit', maxWidth: '19rem' }}>
              <NavigationContainer {...{ views: ACCOUNT_MENU, view, aol }} />
            </div>
          </Grid>
          <Grid item xs={12} md={8} lg={9}>
            <View.component
              key={view} {...{ query, flavour, option, aol }}
            />
          </Grid>
        </Grid>
      </div>
      )
}

export default Account
